<template>
  <div class="custom-select-box" :tabindex="tabindex" @blur="open = false">
    <div class="selected" :class="{ open: open }" @click="open = !open">
      <img v-if="hasIcon && selected.icon" :src="selected.icon" alt="" class="" />
      {{ selected[optionLabel] }}
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <div
        class="item"
        v-for="(option, i) of options"
        :key="i"
        @click="
          selected = option;
          open = false;
          $emit('input', option);
        "
      >
        <img v-if="hasIcon && option.icon" :src="option.icon" alt="" class="" />
        {{ option[optionLabel] }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomSelect",
  props: {
    options: {
      type: Array,
      required: true
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0
    },
    selectedOption: {
      type: Object
    },
    hasIcon: {
      type: Boolean,
      default: true
    },
    optionLabel: {
      type: String,
      default: "label"
    },
    selectedFilterKey: {
      type: String,
      default: "type"
    },
    selectedFilterValue: {
      type: String,
      default: "fieldType"
    }
  },
  data() {
    return {
      selected: this.options.length > 0 ? this.options[0] : null,
      open: false
    };
  },
  mounted() {
    //show the appropriate field type selected in the drop down
    if (this.selectedOption) {
      const selectedOpt = this.options.find(option => {
        return option[this.selectedFilterKey] == this.selectedOption[this.selectedFilterValue];
      });
      this.selected = selectedOpt || this.options[0];
    }

    this.$emit("input", this.selected);
  }
};
</script>

<style lang="scss" scoped>
.custom-select-box {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  /* height: 47px;
  line-height: 47px; */
  font-size: 14px;
  font-weight: normal;
}

.selected {
  background-color: #ffffff;
  border-radius: 3px;
  border: solid 1px #d3dfe4;
  color: #666669;
  padding: 8px;
  padding-left: 11px;
  cursor: pointer;
  user-select: none;
  img {
    margin-right: 7px;
  }
}

.selected.open {
  //border: 1px solid #CE9B2C;
  //border-radius: 6px 6px 0px 0px;
}

.selected:after {
  position: absolute;
  content: "";
  top: 15px;
  right: 10px;
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-color: #4a4a4a transparent transparent transparent;
}

.items {
  color: #000000;
  border-radius: 0px 0px 4px 4px;
  overflow: hidden;
  //border-right: 1px solid #CE9B2C;
  //border-left: 1px solid #CE9B2C;
  //border-bottom: 1px solid #CE9B2C;
  position: absolute;
  background-color: #ffffff;
  left: 1px;
  right: 1px;
  //border-radius: 4px;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.25);
  z-index: 1;
  font-family: Roboto-Medium;
}

.item {
  color: #000000;
  padding-left: 11px;
  cursor: pointer;
  user-select: none;
  line-height: 2.57;
  img {
    margin-right: 7px;
  }
}

.item:hover {
  //background-color: #B68A28;
  background-color: rgba(227, 227, 227, 0.6);
}

.selectHide {
  display: none;
}
</style>
